import { MAX_FACE_PHOTO_URL_KEYS, type ResolveFacePhotoUrlsResult } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/**
 * 면 사진과 합성 에셋(마스크·음영·안내선) 키의 새 표시 URL 을 받는다. 키 종류를 가리지 않고 받은 순서대로 보내며,
 * 미저장 확정 키도 업로드 세션과 무관하게 받는다. 이 갱신은 GET 이라 키가 URL 에 실리므로, 한 건이 전송 URL 상한
 * (TRPC_MAX_URL_LENGTH) 안에 들도록 계약 상한(MAX_FACE_PHOTO_URL_KEYS)씩 나눠 차례로 받는다.
 */
export const useFacePhotoUrls = (productId: string) => {
  const utils = trpc.useUtils();
  return async (photoKeys: string[]): Promise<ResolveFacePhotoUrlsResult> => {
    const photos: ResolveFacePhotoUrlsResult['photos'] = [];
    for (let index = 0; index < photoKeys.length; index += MAX_FACE_PHOTO_URL_KEYS) {
      const batch = await utils.storage.resolveFacePhotoUrls.fetch(
        { productId, photoKeys: photoKeys.slice(index, index + MAX_FACE_PHOTO_URL_KEYS) },
        { staleTime: 0 },
      );
      photos.push(...batch.photos);
    }
    return { photos };
  };
};
